import { z } from 'zod'

export const uuidSchema = z.string().uuid()
export const timestampSchema = z.string().datetime({ offset: true })

export type UUID = z.infer<typeof uuidSchema>
export type Timestamp = z.infer<typeof timestampSchema>

export const paginationSchema = z.object({
  limit: z.coerce.number().int().min(1).max(200).default(50),
  offset: z.coerce.number().int().min(0).default(0),
})
export type Pagination = z.infer<typeof paginationSchema>

export const errorResponseSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
  }),
})
export type ErrorResponse = z.infer<typeof errorResponseSchema>
